import { Redirect, Route } from 'react-router-dom'
import React, { useEffect } from 'react'
import { routes } from '../../constantes/routes'
import { TOKEN_KEY } from '../../constantes/localStorageKeys'
import { useSelector, useDispatch } from 'react-redux'
import { authActions } from '../../actions/authActions'

/* Rutas protegidas, para acceder a estas routes necesitmos tener un token en localStorge y también tener los datos del usuario (userProfile)
 en caso contrario  te redireccciona a la pagina de volverte a autentificar (login) */
const ProtectedRoute = ({
  component: Component,
  ...rest
}) => {
    const userProfile = useSelector(state => state.userProfile)

    const dispatch = useDispatch()
    const login = () => dispatch(authActions.getUserProfileAuth())

    useEffect(() => {
        login()
    }, [])

  return (
    <Route
      {...rest}
          render={props =>
              userProfile.id_Usuario && localStorage.getItem(TOKEN_KEY) ? (
              <Component {...props} />  
        ) : (
          <Redirect to={{ pathname: routes.LOGIN }} />
        )
      }
    />
  )
}

export default ProtectedRoute
